import { atsApiQuery } from '..';

export const candidateSourceApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getCandidateSources: builder.query({
        providesTags: ['GetCandidateSources'],
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `/ats_candidate_sources`,
          };
        },
      }),

      createSourceType: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload = {}) => {
          return {
            method: 'post',
            url: `/ats_candidate_sources/create_root`,
            data: payload,
          };
        },
        invalidatesTags: ['GetCandidateSources'],
      }),

      createSource: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ sourceTypeId, payload = {} } = {}) => {
          return {
            method: 'post',
            url: `/ats_candidate_sources/${sourceTypeId}/create_child`,
            data: payload,
          };
        },
        invalidatesTags: ['GetCandidateSources'],
      }),

      moveSourceType: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ sourceId, payload = {} } = {}) => {
          return {
            method: 'put',
            url: `/ats_candidate_sources/${sourceId}/move`,
            data: payload,
          };
        },
        invalidatesTags: ['GetCandidateSources'],
      }),

      editSource: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ sourceId, payload = {} } = {}) => {
          return {
            method: 'put',
            url: `/ats_candidate_sources/${sourceId}`,
            data: payload,
          };
        },
        invalidatesTags: ['GetCandidateSources'],
      }),

      deleteSource: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ sourceId } = {}) => {
          return {
            method: 'delete',
            url: `/ats_candidate_sources/${sourceId}/delete`,
          };
        },
        invalidatesTags: ['GetCandidateSources'],
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetCandidateSourcesQuery,
  useCreateSourceTypeMutation,
  useCreateSourceMutation,
  useMoveSourceTypeMutation,
  useEditSourceMutation,
  useDeleteSourceMutation,
} = candidateSourceApi;
